export class AGEventEmitter<T> {
  private _events: Map<keyof T, Set<(...args: any[]) => void>>;
  constructor() {
    this._events = new Map();
  }

  on(event: keyof T, listener: (...args: any[]) => void) {
    if (!this._events.has(event)) {
      this._events.set(event, new Set());
    }
    this._events.get(event)?.add(listener);
    return this;
  }

  off(event: keyof T, listener: (...args: any[]) => void) {
    this._events.get(event)?.delete(listener);
    return this;
  }

  emit(event: keyof T, ...args: any[]) {
    this._events.get(event)?.forEach((listener) => {
      listener(...args);
    });
    return this;
  }

  once(event: keyof T, listener: (...args: any[]) => void) {
    const onceListener = (...args: any[]) => {
      this.off(event, onceListener);
      listener(...args);
    };
    return this.on(event, onceListener);
  }
}
